import { render, staticRenderFns } from "./StopMobileNotifications.vue?vue&type=template&id=41076406&scoped=true"
import script from "./StopMobileNotifications.vue?vue&type=script&lang=js"
export * from "./StopMobileNotifications.vue?vue&type=script&lang=js"
import style0 from "./StopMobileNotifications.vue?vue&type=style&index=0&id=41076406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41076406",
  null
  
)

export default component.exports